import React from 'react';
import Invoices from './components/Invoices';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import NextJobSummary from './components/NextJobSummary/NextJobSummary';
import DownloadsBlock from '../PortalDownloadsBlock/App';
import { useDashboardConfig } from './hooks/useDashboardConfig';

export default function Dashboard() {
  const { labels } = useDashboardConfig();
  const { downloadsHeading, downloadsExpiryText, downloadsExpiryDateLabel } = labels;

  return (
    <QueryClientProvider client={DashbordQueryClient}>
      <div className="dashboard-cards-grid">
        <div className="dashboard-card dashboard-card--no-padding">
          <NextJobSummary />
        </div>
        <Invoices />
        <DownloadsBlock
          heading={downloadsHeading}
          expiryNotificationText={downloadsExpiryText}
          expiryDateLabel={downloadsExpiryDateLabel}
        />
      </div>
    </QueryClientProvider>
  );
}
const DashbordQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 60,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});
